import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';

export const Configuracoes: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          <div className="mb-6">
            <h2 className="text-2xl font-bold" style={{ color: '#3d2b56' }}>Configurações</h2>
            <p style={{ color: '#9E9E9E' }}>Configure e gerencie as opções do sistema</p>
          </div>

          <section className="mb-8">
            <div className="mb-6">
              <h3 className="text-sm font-semibold" style={{ color: '#5d54a4' }}>Acesso Rápido aos Catálogos</h3>
              <p style={{ color: '#9E9E9E' }}>Use o menu "Configurações" acima para navegar diretamente para Seguradoras, Produtos ou Situações</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Seguradora */}
              <div className="border rounded-md p-4 shadow-sm" style={{ backgroundColor: '#FFFFFF', borderColor: '#C3B4DE' }}>
                <div>
                  <h5 className="text-md font-semibold" style={{ color: '#3d2b56' }}>Seguradoras</h5>
                  <p className="text-xs mb-3" style={{ color: '#9E9E9E' }}>Gerencie as seguradoras cadastradas</p>
                  <Link to="/seguradoras" className="inline-flex items-center px-3 py-2 text-white rounded-md hover:opacity-80 transition-opacity text-sm" style={{ backgroundColor: '#7A61B2' }}>Gerenciar Seguradoras</Link>
                </div>
              </div>

              {/* Produto */}
              <div className="border rounded-md p-4 shadow-sm" style={{ backgroundColor: '#FFFFFF', borderColor: '#C3B4DE' }}>
                <div>
                  <h5 className="text-md font-semibold" style={{ color: '#3d2b56' }}>Produtos</h5>
                  <p className="text-xs mb-3" style={{ color: '#9E9E9E' }}>Gerencie os produtos disponíveis</p>
                  <Link to="/produtos" className="inline-flex items-center px-3 py-2 text-white rounded-md hover:opacity-80 transition-opacity text-sm" style={{ backgroundColor: '#7A61B2' }}>Gerenciar Produtos</Link>
                </div>
              </div>

              {/* Situação */}
              <div className="border rounded-md p-4 shadow-sm" style={{ backgroundColor: '#FFFFFF', borderColor: '#C3B4DE' }}>
                <div>
                  <h5 className="text-md font-semibold" style={{ color: '#3d2b56' }}>Situações</h5>
                  <p className="text-xs mb-3" style={{ color: '#9E9E9E' }}>Gerencie as situações dos documentos</p>
                  <Link to="/situacoes" className="inline-flex items-center px-3 py-2 text-white rounded-md hover:opacity-80 transition-opacity text-sm" style={{ backgroundColor: '#7A61B2' }}>Gerenciar Situações</Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};